import React, { useState, useEffect } from 'react';
import { NavLink as RouterNavLink, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaCar, FaSearch, FaBars, FaTimes } from 'react-icons/fa';
import Button from './Button';
import Container from './Container';

const HeaderWrapper = styled.header`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  padding: 20px 0;
  background: transparent;
  box-shadow: none;
  transition: background-color 0.3s ease-in-out, padding 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  
  /* ✅ CORREÇÃO: Adicionada altura mínima e flexbox para alinhamento vertical */
  min-height: 80px; /* Define uma altura mínima constante */
  display: flex;
  align-items: center;

  &.scrolled {
    background: ${({ theme }) => theme.colors.lighter};
    box-shadow: ${({ theme }) => theme.shadows.sm};
    padding: 16px 0;
  }
`;

const Navbar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled(RouterNavLink)`
  display: flex;
  align-items: center;
  font-weight: 800;
  font-size: 20px;
  gap: 8px;
  text-decoration: none;
`;

const LogoIcon = styled.div`
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.accent} 100%);
  border-radius: ${({ theme }) => theme.radii.sm};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.lighter};
`;

const NavLinks = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

const StyledNavLink = styled(RouterNavLink)`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
  transition: color ${({ theme }) => theme.transitions.fast};
  text-decoration: none;

  &:hover,
  &.active {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const Hamburger = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.dark};
  z-index: 1001;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`;

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false); 
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleNavigation = () => {
  sessionStorage.setItem('focusPlacaInput', 'true');
  navigate('/');
};


  return (
    <HeaderWrapper className={isScrolled ? 'scrolled' : ''}>
      <Container>
        <Navbar>
          <Logo to="/">
            <LogoIcon><FaCar /></LogoIcon>
            <span>Consulta Veículos</span>
          </Logo>
          <NavLinks>
            {/* <StyledNavLink to="/#recursos">Recursos</StyledNavLink>
            <StyledNavLink to="/#planosW */}
            {/* <StyledNavLink to="/#contato">Contato</StyledNavLink> */}
          </NavLinks>
          <Button href="/" onClick={handleNavigation}>
            <FaSearch /> Nova Consulta
          </Button>

        </Navbar>
      </Container>
    </HeaderWrapper>
  );
};

export default Header;